import { NgModule } from '@angular/core';
import { PageMetaResolver } from '@spartacus/core';

import { KnBrCheckoutPageMetaResolver } from './kn-br-checkout-page-meta.resolver';
import { KnBrContentPageMetaResolver } from './kn-br-content-page-meta.resolver';
import { KnBrSearchPageMetaResolver } from './kn-br-product-search-page-meta.resolver';

@NgModule({
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: KnBrContentPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: KnBrSearchPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: KnBrCheckoutPageMetaResolver,
      multi: true,
    },
  ],
})
export class KnBrMetaResolverModule {}
